module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Arm Sofa_Sand.745df501.png";